export default "__VITE_PUBLIC_ASSET__b0c7b3e4__"